import React from "react";
import { useSelector } from "react-redux";
import { useWatch } from "react-hook-form";

import { i18, trb } from "@utilities";
import {
  InputFormField,
  SelectFormField,
  DateFormField,
  RadioFormField,
  NumberFormField
} from "@components/FormField/HookFormFields";
import {
  selectAvailableCountryOptions,
  selectDocsAllOptions,
  selectDocTypeOptions,
  selectSWCOptions
} from "@redux";
import { FullWidthInputWrapper, HalfWidthInputWrapper } from "@components";
import { yesNo } from "@config/StepperForm";
import { numberFormat } from "@utilities";

export const Beneficiarie = ({ control, beneficiaryIndex, unregister }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);
  const docsAll = useSelector(selectDocsAllOptions);
  const docTypes = useSelector(selectDocTypeOptions);
  const swcOptions = useSelector(selectSWCOptions);

  const otherBenefRegCountry = useWatch({
    control,
    name: `clientBeneficiaries.${beneficiaryIndex}.data.otherClientBenefRegCountry`
  });

  const unregisterOtherCountries = e => {
    if (e.target.value === 1) return;
    unregister([
      `clientBeneficiaries.${beneficiaryIndex}.data.otherClientBenefRegDocType`,
      `clientBeneficiaries.${beneficiaryIndex}.data.otherClientBenefRegDocNo`,
      `clientBeneficiaries.${beneficiaryIndex}.data.otherClientBenefRegDocCountry`,
      `clientBeneficiaries.${beneficiaryIndex}.data.otherClientBenefRegCountSch`
    ]);
  };

  return (
    <>
      {/* neccessary for form value */}
      <InputFormField
        control={control}
        name={`clientBeneficiaries.${beneficiaryIndex}.clientBenefType`}
        className="d-none"
        defaultValue={`BENEF${beneficiaryIndex + 1}`}
      />

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefName`}
          title={trb(i18.Labels.ClientBenefName)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefSurname`}
          title={trb(i18.Labels.ClientBenefSurname)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefId`}
          title={trb(i18.Labels.ClientBenefId)}
        />
      </HalfWidthInputWrapper>

      <FullWidthInputWrapper>
        <InputFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefAddress`}
          title={trb(i18.Labels.ClientBenefAddress)}
        />
      </FullWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefRegCountry`}
          title={trb(i18.Labels.ClientBenefRegCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <DateFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefBirthDate`}
          title={trb(i18.Labels.ClientBenefBirthDate)}
          maxDate={new Date()}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <NumberFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefShare`}
          title={trb(i18.Labels.ClientBenefShare)}
          format={numberFormat().currency}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefTaxCountry`}
          title={trb(i18.Labels.ClientBenefTaxCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefCountry`}
          title={trb(i18.Labels.ClientBenefCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </HalfWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.otherClientBenefRegCountry`}
          title={trb(i18.Labels.OtherClientBenefRegCountry)}
          options={yesNo}
          optionsLabel="label"
          optionsValue="value"
          defaultValue={0}
          onChange={unregisterOtherCountries}
          translationGroup={i18.Labels}
        />
      </FullWidthInputWrapper>
      {(otherBenefRegCountry === 1 || otherBenefRegCountry === "1") && (
        <>
          <HalfWidthInputWrapper>
            <SelectFormField
              control={control}
              name={`clientBeneficiaries.${beneficiaryIndex}.data.otherClientBenefRegDocType`}
              title={trb(i18.Labels.OtherClientBenefRegDocType)}
              options={docsAll}
              optionsLabel="label"
              optionsValue="value"
              isSearchable
              defaultValue="DOCS6"
            />
          </HalfWidthInputWrapper>

          <HalfWidthInputWrapper>
            <InputFormField
              control={control}
              name={`clientBeneficiaries.${beneficiaryIndex}.data.otherClientBenefRegDocNo`}
              title={trb(i18.Labels.OtherClientBenefRegDocNo)}
            />
          </HalfWidthInputWrapper>

          <HalfWidthInputWrapper>
            <SelectFormField
              control={control}
              name={`clientBeneficiaries.${beneficiaryIndex}.data.otherClientBenefRegDocCountry`}
              title={trb(i18.Labels.OtherClientBenefRegDocCountry)}
              options={availableCountries}
              optionsLabel="label"
              optionsValue="value"
              isSearchable
              defaultValue="LT"
            />
          </HalfWidthInputWrapper>

          <FullWidthInputWrapper>
            <RadioFormField
              control={control}
              name={`clientBeneficiaries.${beneficiaryIndex}.data.otherClientBenefRegCountSch`}
              title={trb(i18.Labels.OtherClientBenefRegCountSch)}
              options={yesNo}
              optionsLabel="label"
              optionsValue="value"
              defaultValue={0}
              translationGroup={i18.Labels}
            />
          </FullWidthInputWrapper>
        </>
      )}

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefTaxId`}
          title={trb(i18.Labels.ClientBenefTaxId)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefEmail`}
          title={trb(i18.Labels.ClientBenefEmail)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefIdDoc`}
          title={trb(i18.Labels.ClientBenefIdDoc)}
          options={docTypes}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefDocNo`}
          title={trb(i18.Labels.ClientBenefDocNo)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.beneficiaryFunds`}
          title={trb(i18.Labels.BeneficiaryFunds)}
          options={swcOptions}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name={`clientBeneficiaries.${beneficiaryIndex}.data.clientBenefPhoneNo`}
          title={trb(i18.Labels.ClientBenefPhoneNo)}
          defaultValue="+"
          type="tel"
        />
      </HalfWidthInputWrapper>
    </>
  );
};
